module.exports = __webpack_public_path__ + "static/media/020.be7d2af2.jpg";